<script>
  import ArticleEditor from 'src/pc/pages/ArticleEditor'
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import PostContainer from '../components/PostContainer'
  import DropDown from '../components/Dropdown'
  export default {
    extends: ArticleEditor,
    components: {
      PageLayout,
      SubPageLayout,
      DisplayContainer,
      PostContainer,
      DropDown
    },
    computed: {
      getAccess() {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .article_editor .editor_info p {
    font-size: 13px;
  }
  .article_editor .editor_info .img img {
    width: 80px;
    height: 80px;
  }
  .article_editor .editor_info .name {
    font-size: 20px;
    font-weight: 900;
  }
  .article_editor .editor_info .position {
    margin: 6px 0;
  }
</style>
